module.exports = __webpack_public_path__ + "static/media/r136.e93a90fd.jpg";